// extracted by mini-css-extract-plugin
module.exports = {"loader":"index_loader__D8MCA","rotation":"index_rotation__erspF","container":"index_container__Uz_Xp","loader-overlay":"index_loader-overlay__Gx9kE"};